import {Injectable} from "@angular/core";
import {LogementService} from '../logement.service';
import {environment} from '../../../environments/environment';
import {map} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class IntroJsOptions {

  private readonly BREAKPOINT = 992;

  constructor(private logementService: LogementService) {
  }

  getOptions() {
    return this.logementService.logementCourant.pipe(map(logement => {
      const isDesktop: boolean = document.body.clientWidth > this.BREAKPOINT;
      const isSonergia: boolean = logement?.societe?.partner?.id === environment.SonergiaPartnerId;
      return isDesktop ? this.getDesktopData(isSonergia) : this.getMobileData();
    }));
  }

  private getDesktopData(isSonergia: boolean) {
    return {
      steps: [
        {
          element: '[data-intro="logo"]',
          intro: "Bienvenue dans votre CL&Eacute;A!</br></br>Prenez 20 secondes pour faire un petit tour du propriétaire.",
          position: 'right'
        },
        {
          element: '[data-intro="logement"]',
          intro: "Vous retrouverez ici les informations essentielles à propos de votre logement.",
          position: 'right'
        },
        ...(isSonergia ? [{
          element: '[data-intro="parcours-travaux"]',
          intro: "Comprendre la plateforme CLEA CONCERTO RENOV en 20 secondes.",
          position: 'right'
        }] : []),
        {
          element: '[data-intro="documents"]',
          intro: "Tous les documents importants à conserver : plans, diagnostics, attestations...",
          position: 'right'
        },
        {
          element: '[data-intro="equipements"]',
          intro: "Les équipements de votre logement, comment bien les utiliser et comment bien les entretenir.",
          position: 'right'
        },
        {
          element: '[data-intro="actions"]',
          intro: "Des rappels pour bien entretenir votre logement et conserver ainsi sa qualité mais aussi valoriser votre patrimoine.",
          position: 'right'
        },
        {
          element: '[data-intro="actualites"]',
          intro: "Les dernières actualités CLEA.",
          position: 'right'
        },
        {
          element: '[data-intro="compte"]',
          intro: "La gestion de votre compte et de vos données personnelles.",
          position: 'right'
        },
        {
          element: '[data-intro="notifications"]',
          intro: "Enfin, retrouvez ici ce qui c'est passé récemment.",
          position: 'left'
        },
        {
          element: '[data-intro="logements"]',
          intro: "Pour finir, ajoutez un autre logement si vous avez la chance d'avoir une résidence secondaire ou un bien que vous louez. </br>Lui aussi mérite que l'on veille sur sa qualité !",
          position: 'bottom'
        }
      ],
      showProgress: true,
      nextLabel: 'Suivant >',
      prevLabel: '< Précédent',
      skipLabel: 'Passer l\'aide',
      doneLabel: 'Fin',
      hidePrev: true,
      hideNext: true,
      exitOnEsc: true,
      exitOnOverlayClick: false,
      showStepNumbers: false,
      keyboardNavigation: true,
      showBullets: false,
      scrollToElement: true,
      disableInteraction: true
    };
  }

  private getMobileData() {
    return {
      steps: [
        {
          element: '[data-intro="logo"]',
          intro: "Bienvenue dans votre CL&Eacute;A!</br></br>Prenez 20 secondes pour faire un petit tour du propriétaire.",
          position: 'right'
        },
        {
          element: '[data-intro="logements"]',
          intro: "Ajoutez un autre logement si vous avez la chance d'avoir une résidence secondaire ou un bien que vous louez. </br>Lui aussi mérite que l'on veille sur sa qualité !",
          position: 'bottom'
        },
        {
          element: '[data-intro="notifications"]',
          intro: "Retrouvez ici ce qui c'est passé récemment.",
          position: 'left'
        },
        {
          element: '[data-intro="menu"]',
          intro: "Enfin, trouvez bien plus encore dans le menu principal : informations sur votre logement, autres contacts utiles, conseils pour entretenir la qualité de votre logement...",
          position: 'left'
        },
      ],
      showProgress: true,
      nextLabel: 'Suivant >',
      prevLabel: '< Précédent',
      skipLabel: 'Passer l\'aide',
      doneLabel: 'Fin',
      hidePrev: true,
      hideNext: true,
      exitOnEsc: true,
      exitOnOverlayClick: false,
      showStepNumbers: false,
      keyboardNavigation: false,
      showBullets: false,
      scrollToElement: true,
      disableInteraction: true
    };
  }
}
